import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { ClientPerformanceDetailClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/ClientPerformanceDetail";
import { ClientPerformanceIncomeClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/ClientPerformanceIncome";
import { ClientPerformanceValuationGraphClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/ClientPerformanceValuationGraph";
import { ClientRealisedGainLossClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/ClientRealisedGainLoss";
import { ClientUnRealisedGainLossClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/ClientUnRealisedGainLoss";
import { ModelPortfolioPerformanceDetailClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/ModelPortfolioPerformanceDetail";
import { PerformanceIncomeDataView } from "../../../../../../../../Wrap/Constants/Enums/Portfolio/Performance/PerformanceIncomeDataView";
import {
    PortfolioDashboardPerformanceDetailDispatcher,
    PortfolioDashboardPerformanceDetailStore,
    PortfolioDashboardPerformanceGraphDispatcher,
    PortfolioDashboardPerformanceIncomeDispatcher,
    PortfolioDashboardPerformanceRealisedGainLossDispatcher,
    PortfolioDashboardPerformanceUnRealisedGainLossDisptcher,
} from "../Store/Variable";

export class PortfolioDashboardPerformanceAction {
    public static getPerformanceRealisedGainLoss(selectedAccountHierarchies: string[], from, to, fromInception) {
        const client = new ClientRealisedGainLossClient();
        client.get(selectedAccountHierarchies, from, to, fromInception).onSuccess((data) => {
            PortfolioDashboardPerformanceRealisedGainLossDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
    }

    public static getPerformanceUnRealisedGainLoss(selectedAccountHierarchies: string[], from, to, fromInception) {
        new ClientUnRealisedGainLossClient()
            .get(selectedAccountHierarchies, from, to, fromInception)
            .onSuccess((data) =>
                PortfolioDashboardPerformanceUnRealisedGainLossDisptcher.dispatch({
                    actionType: ActionType.Success,
                    payload: data,
                })
            );
    }

    public static getPerformanceDetail(
        selectedHeadAccoutnHierarechies: string[],
        selectedAccountHierarchies: string[],
        from,
        to,
        performanceMethod,
        assetType,
        viewType,
        fromInception,
        callback?
    ) {
        const client = new ClientPerformanceDetailClient();
        const promise = client.get(
            selectedHeadAccoutnHierarechies,
            selectedAccountHierarchies,
            from,
            to,
            performanceMethod,
            assetType,
            fromInception,
            viewType
        );
        promise.onSuccess((result) => {
            const _result = result.map((data) => {
                const InvestmentHoldingsGroup = data.AssetPerformanceDetail.filter(
                    (ele) => ele.AssetSubType !== "Model" && ele.AssetSubType !== "Off-Platform Investments"
                );
                const ModelProtofoiloGroup = data.AssetPerformanceDetail.filter((ele) => ele.AssetSubType == "Model");
                const OPIGroup = data.AssetPerformanceDetail.filter(
                    (ele) => ele.AssetSubType == "Off-Platform Investments"
                );
                const _InvestmestHoldingsGroup = InvestmentHoldingsGroup.map((ele) => {
                    const _items = ele.PerformanceDetails.map((p) => {
                        return { isModel: false, ...p };
                    });
                    return { ...ele, PerformanceDetailsWithFlag: _items };
                });
                const _OPIGroup = OPIGroup.map((ele) => {
                    const _items = ele.PerformanceDetails.map((p) => {
                        return { isModel: false, ...p };
                    });
                    return { ...ele, PerformanceDetailsWithFlag: _items };
                });
                const _ModelProtofoiloGroup = ModelProtofoiloGroup.map((ele) => {
                    const _items = ele.PerformanceDetails.map((p) => {
                        return { underlyingModel: null, isModel: true, isToogle: false, ...p };
                    });
                    return { ...ele, PerformanceDetailsWithFlag: _items };
                });
                return {
                    ...data,
                    ModelAssetPerformanceDetail: _ModelProtofoiloGroup,
                    NonModelAssetPerformanceDetail: _InvestmestHoldingsGroup,
                    OPIAssetPerformanceDetail: _OPIGroup,
                };
            });
            if (callback) {callback();} 
            PortfolioDashboardPerformanceDetailDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: _result,
            });
        });
    }

    public static getDetailMPDetail(
        isToogle,
        productIndex,
        from,
        to,
        performanceMethod,
        assetType,
        view,
        instrumentIds,
        callback?,
        modelId?
    ) {
        const data = PortfolioDashboardPerformanceDetailStore.getData();
        const _obj = data[productIndex].ModelAssetPerformanceDetail[0].PerformanceDetailsWithFlag.find(
            (ele) => ele.InstrumentCode == modelId
        );
        const _index = data[productIndex].ModelAssetPerformanceDetail[0].PerformanceDetailsWithFlag.findIndex(
            (ele) => ele.InstrumentCode == modelId
        );
        if (!isToogle || (isToogle && _obj.underlyingModel)) {
            data[productIndex].ModelAssetPerformanceDetail[0].PerformanceDetailsWithFlag[_index].isToogle = isToogle;
            callback(data);
        } else {
            const client = new ModelPortfolioPerformanceDetailClient();
            const promise = client.get(from, to, performanceMethod, assetType, instrumentIds, view);
            promise.onSuccess((models) => {
                data[productIndex].ModelAssetPerformanceDetail[0].PerformanceDetailsWithFlag[
                    _index
                ].isToogle = isToogle;
                data[productIndex].ModelAssetPerformanceDetail[0].PerformanceDetailsWithFlag[
                    _index
                ].underlyingModel = models;
                callback(data);
            });
        }
    }

    public static getPerformanceGraphData(
        selectedHeadAccoutnHierarechies: string[],
        selectedAccountHierarchies: string[],
        from,
        to,
        fromInception
    ): void {
        const client = new ClientPerformanceValuationGraphClient();
        client
            .get(from, to, fromInception, selectedAccountHierarchies, selectedHeadAccoutnHierarechies)
            .onSuccess((result) => {
                PortfolioDashboardPerformanceGraphDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });
            })
            .onError((err) =>
                PortfolioDashboardPerformanceGraphDispatcher.dispatch({ actionType: ActionType.Error, payload: err })
            );
    }

    public static getPerformanceIncomeData(
        selectedheadAccountHierarchies: string[],
        selectedAccountHierarchies: string[],
        from,
        to,
        selectedView: PerformanceIncomeDataView,
        fromInception
    ) {
        new ClientPerformanceIncomeClient()
            .get(selectedheadAccountHierarchies, selectedAccountHierarchies, from, to, fromInception, selectedView)
            .onSuccess((data) =>
                PortfolioDashboardPerformanceIncomeDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: data,
                })
            );
    }
}
